import { GridColDef } from "@mui/x-data-grid";
import EditMenuItem from "components/table/EditMenuItem";
import { MoreActionsButton } from "components/table/MoreActionsButton";
import { Branch, ofBranch } from "types/branch";
import { TLike } from "../utils/i18n/TLike";

export function branchCols(t: TLike): GridColDef<Branch>[] {
  return [
    {
      field: ofBranch("id"),
      headerName: "Id",
    },
    {
      field: ofBranch("name"),
      headerName: "Name",
      flex: 1,
    },
    {
      field: ofBranch("abbreviation"),
      headerName: "Abbreviation",
      flex: 1,
    },
    {
      field: ofBranch("contact"),
      headerName: "Contact",
      flex: 1,
    },
    {
      field: ofBranch("authenticationType"),
      headerName: "Authentication",
      flex: 1,
      valueFormatter: (value) => {
        return t(`common.BranchAuthenticationType.${value}`);
      },
    },
    {
      field: "menu",
      headerName: "",
      renderCell: function render({ row }) {
        return (
          <MoreActionsButton>
            <EditMenuItem resource={"branches"} id={row.id} />
          </MoreActionsButton>
        );
      },
      align: "center",
      maxWidth: 80,
      filterable: false,
      sortable: false,
      disableExport: true,
      disableColumnMenu: true,
    },
  ];
}
